import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-46b6068c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "launch-card-status end"
};
const _hoisted_2 = {
  key: 1,
  class: "launch-card-status ongoing"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/bycsi-root/bybit/deadpool/image-8ebf53f2e440422d87088769020c3b33.png"
}, null, -1));
const _hoisted_4 = {
  class: "launch-card"
};
const _hoisted_5 = {
  class: "launch-card-info"
};
const _hoisted_6 = {
  class: "launch-card-content"
};
const _hoisted_7 = {
  class: "launch-card-content-name-wrapper"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "launch-card-content-text"
};
const _hoisted_10 = {
  class: "launch-card-content-desc"
};
const _hoisted_11 = {
  class: "launch-card-content-label"
};
const _hoisted_12 = {
  class: "launch-card-content-price"
};
const _hoisted_13 = {
  class: "launch-card-countdown"
};
const _hoisted_14 = {
  key: 0,
  class: "launch-card-countdown-title"
};
const _hoisted_15 = {
  key: 1,
  class: "launch-card-countdown-title"
};
const _hoisted_16 = {
  key: 2,
  class: "launch-card-countdown-content"
};
const _hoisted_17 = {
  class: "launch-card-list"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "normal-icon",
  src: "/bycsi-root/bybit/deadpool/image-4219e30164354dc3bab39c4eaf64896a.svg"
}, null, -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "hover-icon",
  src: "/bycsi-root/bybit/deadpool/image-544ff0697ed64b3fafc343dcc2fec094.svg"
}, null, -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/bycsi-root/bybit/deadpool/image-77c9516450e74dbba3000ab27e072631.svg"
}, null, -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "normal-icon",
  src: "/bycsi-root/bybit/deadpool/image-4219e30164354dc3bab39c4eaf64896a.svg"
}, null, -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "hover-icon",
  src: "/bycsi-root/bybit/deadpool/image-544ff0697ed64b3fafc343dcc2fec094.svg"
}, null, -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/bycsi-root/bybit/deadpool/image-77c9516450e74dbba3000ab27e072631.svg"
}, null, -1));
const _hoisted_24 = {
  key: 2,
  class: "launch-card-footer"
};
const _hoisted_25 = {
  key: 0,
  class: "share"
};
const _hoisted_26 = {
  class: "share-text"
};
const _hoisted_27 = ["innerHTML"];
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "share-action-icon"
}, null, -1));
const _hoisted_29 = {
  key: 1,
  class: "share"
};
const _hoisted_30 = {
  class: "share-text"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "share-action-icon"
}, null, -1));
import { reactive, computed, toRefs, watch, onBeforeUnmount } from 'vue';
import { countdown } from '@/utils/tools';
import { useRouter } from 'vue-router';
import { toFormat, gt } from '@/utils/number';
import pushEvent from '@bfe/by-gtm';
import { getRelativeUrl } from '@bfe/by-env';
import { useI18n } from 'vue-i18n';
import { saPushEvent } from '@/utils/sensors';
import { useLaunchpad } from '@/hooks/launchpad';
import { SPOT_LAUNCHPAD_HOME_MAJOR_CLICK } from '@/config/sensors';
import { useShare } from '@/hooks/useShare';
import { toLogin, noBybitToRegister } from '@/utils/jumpLink';
import { useStore } from 'vuex';
import TextLink from '@/components/text-link';
import CardItem from './ItemBase';
import Countdown from '../CountdownNew';
import { useConstant } from '../../hooks/constant';
export default {
  __name: 'Card',
  props: {
    data: {
      type: Object,
      default: null
    },
    diffTime: {
      type: Number,
      default: 0
    }
  },
  setup(__props) {
    const props = __props;
    const {
      t,
      locale
    } = useI18n();
    const {
      computeStatus
    } = useLaunchpad();
    const {
      PROJECTS
    } = useConstant();
    const router = useRouter();
    const store = useStore();
    const isLogin = computed(() => store.state.user.userstate === 1);
    const {
      openShareModal
    } = useShare();
    const state = reactive({
      isEnd: false,
      status: {
        label: t('lpn_active_status6')
      },
      label: '',
      countdown: {
        d: '00',
        h: '00',
        m: '00',
        s: '00'
      }
    });
    const sharePrizePoolText = t('sharePrizePool', {
      prizepool: `<b>${toFormat(props.data?.referralTotalAmount)}</b>`,
      token: `<b>${props.data?.referralToken}</b>`
    });

    // const project = props.data;
    const activities = props.data?.projectActivityList || [];
    const {
      data,
      diffTime
    } = toRefs(props); // eslint-disable-line vue/no-dupe-keys
    const status = computeStatus(props.data, Date.now());
    const isEnded = status > 7;
    const afterBuying = status >= 4;
    const hasReferral = props.data?.referralToken != null && gt(props.data?.referralTotalAmount, 0);
    const mntActivity = activities?.[0];
    const usdtActivity = activities?.[1];
    const priceInfo = usdtActivity || mntActivity;
    const mntItem = {
      icon: mntActivity?.icon,
      title: mntActivity?.type === 0 ? t('subscribeToBuyTokenWithCurrency', {
        token: props.data?.currencyName,
        currency: mntActivity?.currencyName
      }) : t('joinLotteryWinAllocation', {
        token: props.data?.currencyName,
        currency: mntActivity?.currencyName
      }),
      infoList: [{
        label: `${t('lp_issue_num')} (${props.data?.currencyName})`,
        content: `${toFormat(mntActivity?.issueAmount)}`
      }, {
        label: t('lpn_upper_limit'),
        content: `${toFormat(mntActivity?.limitAmount || '')} ${props.data?.currencyName}`
      }, afterBuying ? {
        label: t('lpn_input_quantity'),
        content: `${toFormat(mntActivity?.totalAmount)} ${mntActivity?.currencyName}`
      } : null, afterBuying ? {
        label: t('lpn_participant'),
        content: toFormat(mntActivity?.totalUser)
      } : null].filter(Boolean)
    };
    const usdtItem = {
      icon: usdtActivity?.icon,
      title: usdtActivity?.type === 0 ? t('subscribeToBuyTokenWithCurrency', {
        token: props.data?.currencyName,
        currency: usdtActivity?.currencyName
      }) : t('joinLotteryWinAllocation', {
        token: props.data?.currencyName,
        currency: usdtActivity?.currencyName
      }),
      infoList: [{
        label: `${t('lp_issue_num')} (${props.data?.currencyName})`,
        content: `${toFormat(usdtActivity?.issueAmount)}`
      }, {
        label: t('lpn_win_prize'),
        content: `${toFormat(usdtActivity?.limitAmount)} ${props.data?.currencyName}`
      }, afterBuying ? {
        label: t('lpn_input_quantity'),
        content: `${toFormat(usdtActivity?.totalAmount)} ${usdtActivity?.currencyName}`
      } : null, afterBuying ? {
        label: t('lpn_participant'),
        content: toFormat(usdtActivity?.totalUser)
      } : null].filter(Boolean)
    };

    // 跳转详情页
    const handleToDetail = () => {
      if (!props.data.code) return;
      const btnName = isEnded ? t('viewDetails') : t('lpn_btn_join_now');
      saPushEvent(SPOT_LAUNCHPAD_HOME_MAJOR_CLICK, {
        page_name: 'LpadHomePage',
        plate_area: 'OngoingProject',
        project_name: props.data.name,
        button_name: btnName || ''
      });
      pushEvent('click', 'spot_launchpadlplm', props.data.name);
      // 进行中，未登录用户，判断是否有bybit账号
      if (!isEnded && !isLogin.value && noBybitToRegister('spotx_launchpad_ongoing')) {
        return;
      }
      router.push(`/${locale.value}/trade/spot/launchdetail/?id=${props.data.code}`);
    };
    const handleShare = () => {
      if (!isLogin.value) {
        if (noBybitToRegister('spotx_launchpad_ongoing')) {
          return;
        }
        toLogin(window.location.href);
        return;
      }
      openShareModal({
        token: props.data?.currencyName,
        prizepool: props.data?.issueAmount || '',
        id: props.data?.code
      });
    };
    const goReferralCenter = () => {
      if (!isLogin.value) {
        if (noBybitToRegister('spotx_launchpad_ongoing')) {
          return;
        }
        toLogin(window.location.href);
      } else {
        window.open(`/${locale.value}/trade/spot/spotx/referral-records-rules?source=1`);
      }
    };
    const shareIcon = '/bycsi-root/bybit/deadpool/image-f2780762094e490292f4467d0698fcf5.svg';
    let timer = null;
    // 停止倒计时
    const stopCountdown = () => {
      if (timer) clearInterval(timer);
    };
    // 开始倒计时
    const startCountdown = () => {
      stopCountdown();
      if (!data.value.allocationEndTime) return;
      const current = Date.now() + diffTime.value;
      let endTime = 0;
      if (current > data.value.endTime) {
        // 5. 分配期：距离公布结果
        state.label = t('resultsAnnouncementTime'); // TODO:距离分配结束 => 距离公布结果
        endTime = data.value.allocationEndTime;
      } else if (current > data.value.startTime) {
        // 4. 认购期：距离认购结束
        state.label = t('saleEndsIn'); // TODO:距离认购截止 => 距离认购结束
        endTime = data.value.endTime;
      } else {
        // 2. 快照期：距离认购开始
        state.label = t('saleStartsIn');
        endTime = data.value.startTime;
      }
      state.countdown = countdown(current, endTime);
      if (current > data.value.allocationEndTime) {
        stopCountdown();
        return;
      }
      timer = setTimeout(startCountdown, 480);
    };

    // 监听结束时间和时间差变化，重新进行倒计时
    watch([diffTime, data], () => {
      state.isEnd = false;
      startCountdown();
    }, {
      immediate: true
    });

    // 销毁之前清理计时器
    onBeforeUnmount(() => {
      stopCountdown();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["launch-card-wrapper", isEnded ? '' : 'onGoing'])
      }, [isEnded ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(t)('lp_active_end')), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_2, [_hoisted_3, _createTextVNode(_toDisplayString(_unref(t)('lp_active_active')), 1)])), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
        class: "launch-card-content-icon",
        src: _unref(getRelativeUrl)(_unref(data)?.icon)
      }, null, 8, _hoisted_8), _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(data)?.currencyName) + " " + _toDisplayString(_unref(t)('tokenSale')), 1)]), _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(PROJECTS)[_unref(data).code]?.desc || _unref(data)?.title), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('price')), 1), _createElementVNode("div", _hoisted_12, " 1 " + _toDisplayString(_unref(data)?.currencyName) + "=" + _toDisplayString(_unref(toFormat)(_unref(priceInfo)?.exchangedPrice || 0)) + " " + _toDisplayString(_unref(priceInfo)?.currencyName), 1)]), _createElementVNode("div", _hoisted_13, [isEnded ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(t)('lpn_notice10')), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(state.label), 1)), !isEnded ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_unref(Countdown), {
        data: state.countdown
      }, null, 8, ["data"])])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_17, [_createVNode(_unref(CardItem), {
        icon: mntItem.icon,
        title: mntItem.title,
        "info-list": mntItem.infoList
      }, {
        default: _withCtx(() => [isEnded ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "launch-action-end",
          onClick: handleToDetail
        }, [_createTextVNode(_toDisplayString(_unref(t)('viewDetails')) + " ", 1), _hoisted_18, _hoisted_19])) : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "launch-action-ongoing",
          onClick: handleToDetail
        }, [_createTextVNode(_toDisplayString(_unref(t)('lpn_btn_join_now')) + " ", 1), _hoisted_20]))]),
        _: 1
      }, 8, ["icon", "title", "info-list"]), _unref(activities)?.length > 1 ? (_openBlock(), _createBlock(_unref(CardItem), {
        key: 0,
        icon: usdtItem.icon,
        title: usdtItem.title,
        "info-list": usdtItem.infoList
      }, {
        default: _withCtx(() => [isEnded ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "launch-action-end",
          onClick: handleToDetail
        }, [_createTextVNode(_toDisplayString(_unref(t)('viewDetails')) + " ", 1), _hoisted_21, _hoisted_22])) : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "launch-action-ongoing",
          onClick: handleToDetail
        }, [_createTextVNode(_toDisplayString(_unref(t)('lpn_btn_join_now')) + " ", 1), _hoisted_23]))]),
        _: 1
      }, 8, ["icon", "title", "info-list"])) : _createCommentVNode("", true)])]), !isEnded ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_unref(hasReferral) ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("img", {
        class: "share-icon",
        src: shareIcon
      }), _createElementVNode("div", _hoisted_26, [_createElementVNode("span", {
        innerHTML: _unref(sharePrizePoolText)
      }, null, 8, _hoisted_27), _createVNode(_unref(TextLink), {
        text: _unref(t)('viewDetails'),
        onClick: goReferralCenter
      }, null, 8, ["text"])]), _createElementVNode("div", {
        class: "share-action",
        onClick: handleShare
      }, [_createTextVNode(_toDisplayString(_unref(t)('lpn_share_earn')) + " ", 1), _hoisted_28])])) : (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("img", {
        class: "share-icon",
        src: shareIcon
      }), _createElementVNode("div", _hoisted_30, [_createElementVNode("span", null, _toDisplayString(_unref(t)('referFriendsEarnToget')), 1)]), _createElementVNode("div", {
        class: "share-action",
        onClick: handleShare
      }, [_createTextVNode(_toDisplayString(_unref(t)('lpn_share_earn')) + " ", 1), _hoisted_31])]))])) : _createCommentVNode("", true)], 2);
    };
  }
};